import { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Divider, Grid, Stack, TextField } from '@mui/material';

import InputLabel from 'src/berry/ui-component/extended/Form/InputLabel.jsx';
import { gridSpacing } from 'src/berry/store/constant.jsx';

import ModalsContext from 'src/context/modals.jsx';

const EraForm = () => {
	const {
		hide,
		data: { data, clb },
	} = useContext(ModalsContext);

	const { handleSubmit, control } = useForm({
		defaultValues: {
			name: data?.name || '',
			year: data?.stats?.year ?? '',
			population: data?.stats?.population ?? '',
			members: data?.stats?.members ?? '',
			highway: data?.stats?.highway ?? '',
			covered: data?.stats?.covered ?? '',
		},
	});

	const on_submit = (form_data) => {
		const stats = {
			year: Number(form_data.year),
			population: Number(form_data.population),
			members: Number(form_data.members),
			highway: Number(form_data.highway),
			covered: Number(form_data.covered),
		};
		if (Object.values(stats).some((v) => Number.isNaN(v)))
			return;
		clb({ name: form_data.name, stats });
		hide();
	};

	return (
		<>
			<Grid container spacing={gridSpacing} sx={{ pb: '30px' }}>
				<Grid item xs={12}>
					<Stack spacing={gridSpacing}>
						<InputLabel>Name</InputLabel>
						<Controller
							name="name"
							control={control}
							defaultValue=""
							render={({ field }) => <TextField {...field} fullWidth />}
						/>
					</Stack>
				</Grid>

				<Grid item xs={12}>
					<Divider />
				</Grid>

				<Grid item xs={12} md={6}>
					<Stack spacing={gridSpacing}>
						<InputLabel>Year</InputLabel>
						<Controller
							name="year"
							control={control}
							defaultValue=""
							render={({ field }) => <TextField {...field} type="number" fullWidth />}
						/>
					</Stack>
				</Grid>
				<Grid item xs={12} md={6}>
					<Stack spacing={gridSpacing}>
						<InputLabel>Population</InputLabel>
						<Controller
							name="population"
							control={control}
							defaultValue=""
							render={({ field }) => <TextField {...field} type="number" fullWidth />}
						/>
					</Stack>
				</Grid>
				<Grid item xs={12} md={6}>
					<Stack spacing={gridSpacing}>
						<InputLabel>Members</InputLabel>
						<Controller
							name="members"
							control={control}
							defaultValue=""
							render={({ field }) => <TextField {...field} type="number" fullWidth />}
						/>
					</Stack>
				</Grid>
				<Grid item xs={12} md={6}>
					<Stack spacing={gridSpacing}>
						<InputLabel>Highway</InputLabel>
						<Controller
							name="highway"
							control={control}
							defaultValue=""
							render={({ field }) => <TextField {...field} type="number" fullWidth />}
						/>
					</Stack>
				</Grid>
				<Grid item xs={12} md={6}>
					<Stack spacing={gridSpacing}>
						<InputLabel>Covered</InputLabel>
						<Controller
							name="covered"
							control={control}
							defaultValue=""
							render={({ field }) => <TextField {...field} type="number" fullWidth />}
						/>
					</Stack>
				</Grid>
			</Grid>

			<Grid container>
				<Grid item xs={12}>
					<Divider />
				</Grid>
				<Grid item xs={12}>
					<Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" sx={{ mt: '15px' }}>
						<Button color="error" onClick={hide}>
							Cancel
						</Button>
						<Button variant="contained" size="small" onClick={handleSubmit(on_submit)}>
							Save
						</Button>
					</Stack>
				</Grid>
			</Grid>
		</>
	);
};

export default EraForm;
